webpackJsonp([61057078619453],{

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(97);

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(7);
	var settle = __webpack_require__(103);
	var buildURL = __webpack_require__(105);
	var parseHeaders = __webpack_require__(111);
	var isURLSameOrigin = __webpack_require__(109);
	var createError = __webpack_require__(54);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(107);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(7);
	var bind = __webpack_require__(55);
	var Axios = __webpack_require__(99);
	var defaults = __webpack_require__(27);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(52);
	axios.CancelToken = __webpack_require__(98);
	axios.isCancel = __webpack_require__(53);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(112);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(52);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(27);
	var utils = __webpack_require__(7);
	var InterceptorManager = __webpack_require__(100);
	var dispatchRequest = __webpack_require__(101);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(7);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(102);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(7);
	var transformData = __webpack_require__(104);
	var isCancel = __webpack_require__(53);
	var defaults = __webpack_require__(27);
	var isAbsoluteURL = __webpack_require__(108);
	var combineURLs = __webpack_require__(106);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),

/***/ 102:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(54);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(7);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(7);
	var normalizeHeaderName = __webpack_require__(110);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(51);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(51);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(7);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),

/***/ 106:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(7);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),

/***/ 108:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(7);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(7);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(7);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),

/***/ 112:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(55);
	var isBuffer = __webpack_require__(154);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),

/***/ 154:
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	module.exports = function isBuffer (obj) {
	  return obj != null && obj.constructor != null &&
	    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 2067:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @class ResizeListener
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @description extendable component that uses the provided .handleResize() method
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/* eslint-env browser */
	
	var defaultThrottleRate = 200;
	
	var ResizeListener = function (_React$Component) {
	  _inherits(ResizeListener, _React$Component);
	
	  function ResizeListener() {
	    _classCallCheck(this, ResizeListener);
	
	    var _this = _possibleConstructorReturn(this, (ResizeListener.__proto__ || Object.getPrototypeOf(ResizeListener)).call(this));
	
	    _this._handleResize = _this._handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResizeListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // We need to bind again when passing to the window listner in for IE10
	      this._handleResize = this._handleResize.bind(this);
	      window.addEventListener('resize', this._handleResize);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this._handleResize);
	    }
	  }, {
	    key: '_handleResize',
	    value: function _handleResize() {
	      var _this2 = this;
	
	      if (!this._resizeTimer) {
	        this.props.handleResize();
	
	        // throttle the listener
	        this._resizeTimer = setTimeout(function () {
	          // if a resize came in while we paused, adjust again once after the pause before we start listening again
	          if (_this2._pendingResize) {
	            _this2.props.handleResize();
	          }
	
	          _this2._resizeTimer = false;
	        }, this.props.throttleRate);
	      } else {
	        this._pendingResize = true;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ResizeListener;
	}(_react2.default.Component);
	
	ResizeListener.propTypes = {
	  handleResize: _propTypes2.default.func.isRequired,
	  throttleRate: _propTypes2.default.number
	};
	ResizeListener.defaultProps = {
	  throttleRate: defaultThrottleRate
	};
	exports.default = ResizeListener;

/***/ }),

/***/ 2068:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.setTag = setTag;
	exports.passProps = passProps;
	/**
	 * @file style constants and static functions
	 */
	
	var block = exports.block = { display: 'block' };
	
	var sizerWrapperStyles = exports.sizerWrapperStyles = _extends({}, block, {
	  position: 'absolute',
	  left: '-20000px',
	  width: '100%'
	});
	
	var spreaderStyles = exports.spreaderStyles = _extends({}, block, {
	  overflow: 'hidden',
	  height: '0px',
	  width: '100%'
	});
	
	var wrapperStyles = exports.wrapperStyles = _extends({}, block, {
	  position: 'relative',
	  overflow: 'hidden'
	});
	
	var childrenStyles = exports.childrenStyles = _extends({}, block, {
	  width: '100%'
	});
	
	var tagWhitelist = ['div', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span'];
	
	function setTag(tagName) {
	  if (!tagName) {
	    return 'div';
	  }
	
	  var foundTag = tagWhitelist.find(function (tag) {
	    return tagName === tag;
	  });
	  return foundTag || 'div';
	}
	
	var eventWhitelist = ['onClick', 'onContextMenu', 'onDoubleClick', 'onDrag onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp'];
	
	function passProps(props) {
	  return (Object.keys(props) || {}).reduce(function (passed, key) {
	    var hasEvent = eventWhitelist.find(function (event) {
	      return event === key;
	    });
	    var passedCopy = _extends({}, passed);
	
	    if (hasEvent) {
	      passedCopy[key] = props[key];
	    }
	
	    return passedCopy;
	  }, {});
	}
	
	// Polyfill
	if (!Array.prototype.find) {
	  /* eslint no-extend-native: [0], prefer-rest-params: [0] */
	  Array.prototype.find = function find(predicate) {
	    if (this == null) {
	      throw new TypeError('Array.prototype.find called on null or undefined');
	    }
	    if (typeof predicate !== 'function') {
	      throw new TypeError('predicate must be a function');
	    }
	    var list = Object(this);
	    var length = list.length >>> 0; // eslint-disable-line
	    var thisArg = arguments[1];
	    var value = void 0;
	
	    for (var i = 0; i < length; i++) {
	      value = list[i];
	      if (predicate.call(thisArg, value, i, list)) {
	        return value;
	      }
	    }
	    return undefined;
	  };
	}

/***/ }),

/***/ 2069:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(10);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ResizeListener = __webpack_require__(2067);
	
	var _ResizeListener2 = _interopRequireDefault(_ResizeListener);
	
	var _constants = __webpack_require__(2068);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @class Shiitake
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @description React line clamp that won't get you fired
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Shiitake = function (_React$Component) {
	  _inherits(Shiitake, _React$Component);
	
	  function Shiitake(props) {
	    _classCallCheck(this, Shiitake);
	
	    var _this = _possibleConstructorReturn(this, (Shiitake.__proto__ || Object.getPrototypeOf(Shiitake)).call(this, props));
	
	    var allChildren = typeof props.children === 'string' ? props.children : '';
	    var children = props.renderFullOnServer ? allChildren : '';
	
	    _this.state = {
	      lastCalculatedWidth: -1,
	      testChildren: '',
	      children: children,
	      allChildren: allChildren
	    };
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    return _this;
	  }
	
	  _createClass(Shiitake, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleResize();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var _this2 = this;
	
	      var children = newProps.children,
	          lines = newProps.lines;
	
	      // if we've got different children, reset and retest
	
	      if (children !== this.state.allChildren) {
	        var allChildren = typeof children === 'string' ? children : '';
	        this.setState({ lastCalculatedWidth: -1, children: children, allChildren: allChildren });
	        this._setTestChildren(0, children.length);
	      } else if (lines !== this.props.lines) {
	        // for a lines number change, retrim the full string
	        this._callDeffered(function () {
	          _this2.setState({ testChildren: '', lastCalculatedWidth: -1, children: _this2.state.allChildren });
	          _this2.handleResize();
	        });
	      }
	    }
	  }, {
	    key: '_callDeffered',
	    value: function _callDeffered(func) {
	      var _this3 = this;
	
	      setTimeout(function () {
	        if (_this3.spreader) {
	          func.bind(_this3)();
	        }
	      }, 0);
	    }
	  }, {
	    key: '_checkHeight',
	    value: function _checkHeight(start, end) {
	      var contentHeight = this.testChildren.offsetHeight;
	      var halfWay = end - Math.round((end - start) / 2);
	
	      // TODO: refine this flag, make simpler
	      var linear = end - start < 6 || end === this.state.testChildren.length && end !== this.state.allChildren.length || this.state.lastCalculatedWidth > -1;
	
	      // do we need to trim?
	      if (contentHeight > this._targetHeight) {
	        // chunk/ trim down
	        if (linear) {
	          this._setTestChildren(this.state.testChildren.length, this.state.testChildren.length - 1);
	        } else {
	          this._setTestChildren(start, halfWay);
	        }
	
	        // we've used all the characters in a window expand situation
	      } else if (this.state.testChildren.length === this.state.allChildren.length) {
	        this._setChildren();
	      } else if (linear) {
	        // if we just got here by decrementing one, we're good
	        if (start > end) {
	          this._setChildren();
	        } else {
	          // window grew, increment up one
	          this._setTestChildren(this.state.testChildren.length, this.state.testChildren.length + 1);
	        }
	      } else {
	        // chunk up, still in binary search mode
	        this._setTestChildren(halfWay, end);
	      }
	    }
	
	    // this will render test children trimmed at halfway point then come around to test height again
	
	  }, {
	    key: '_setTestChildren',
	    value: function _setTestChildren(start, end) {
	      // if it's within the treshold or has already been calculated, go linear
	      var trimEnd = end - start < 6 || this.state.lastCalculatedWidth > -1 ? end : end - Math.round((end - start) / 2);
	
	      this.setState({ testChildren: this.state.allChildren.substring(0, trimEnd) });
	      this._callDeffered(this._checkHeight.bind(this, start, end));
	    }
	  }, {
	    key: '_setChildren',
	    value: function _setChildren() {
	      var onTruncationChange = this.props.onTruncationChange;
	      var allChildren = this.state.allChildren;
	
	      var children = this.state.allChildren;
	      var oldChildren = this.state.children;
	
	      // are we actually trimming?
	      if (this.state.testChildren.length < this.state.allChildren.length) {
	        children = this.state.testChildren.split(' ').slice(0, -1).join(' ');
	      }
	      this._handlingResize = false;
	      this.setState({ children: children, lastCalculatedWidth: this.spreader.offsetWidth });
	
	      // if we  changed the length of the visible string, check if we're switching from truncated to
	      // not-truncated or vica versa
	      if (children.length !== oldChildren.length) {
	        var wasTruncatedBefore = oldChildren.length !== allChildren.length;
	        var isTruncatedNow = children.length !== allChildren.length;
	
	        if (wasTruncatedBefore !== isTruncatedNow && typeof onTruncationChange === 'function') {
	          onTruncationChange(isTruncatedNow);
	        }
	      }
	    }
	
	    // adds the trimmed content to state and fills the sizer on resize events
	
	  }, {
	    key: 'handleResize',
	    value: function handleResize() {
	      // if we don't have a spreader, let it come around again
	      if (!this.spreader) {
	        return;
	      }
	
	      var availableWidth = this.spreader.offsetWidth;
	      this._targetHeight = this.sizer.offsetHeight;
	
	      // set the max height right away, so that the resize throttle doesn't allow line break jumps
	      // also populate with the full string if we don't have a working trimmed string yet
	      this.setState({ fixHeight: this._targetHeight, children: this.state.children || this.state.allChildren });
	
	      // was there a width change, or lines change?
	      if (availableWidth !== this.state.lastCalculatedWidth && !this._handlingResize) {
	        this._handlingResize = true;
	
	        // first render?
	        if (this.state.testChildren === '') {
	          // give it the full string and check the height
	          this.setState({ testChildren: this.state.allChildren });
	          this._callDeffered(this._checkHeight.bind(this, 0, this.state.allChildren.length));
	
	          // window got smaller?
	        } else if (availableWidth < this.state.lastCalculatedWidth) {
	          // increment down one
	          this._callDeffered(this._checkHeight.bind(this, this.state.testChildren.length, this.state.testChildren.length - 1));
	
	          // window got larger?
	        } else {
	          // increment up one
	          this._callDeffered(this._checkHeight.bind(this, this.state.testChildren.length, this.state.testChildren.length + 1));
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          renderFullOnServer = _props.renderFullOnServer,
	          className = _props.className,
	          throttleRate = _props.throttleRate,
	          overflowNode = _props.overflowNode;
	      var _state = this.state,
	          fixHeight = _state.fixHeight,
	          children = _state.children,
	          testChildren = _state.testChildren;
	
	      var tagNames = { main: (0, _constants.setTag)(this.props.tagName) };
	
	      var vertSpacers = [];
	      for (var i = 0; i < this.props.lines; i++) {
	        vertSpacers.push(_react2.default.createElement(
	          'span',
	          { style: _constants.block, key: i },
	          'W'
	        ));
	      }
	
	      var thisHeight = (fixHeight || 0) + 'px';
	      var maxHeight = renderFullOnServer ? '' : thisHeight;
	
	      var overflow = testChildren.length < this.state.allChildren.length ? overflowNode : null;
	
	      return _react2.default.createElement(
	        tagNames.main,
	        _extends({ className: className || '' }, (0, _constants.passProps)(this.props)),
	        _react2.default.createElement(_ResizeListener2.default, { handleResize: this.handleResize, throttleRate: throttleRate }),
	        _react2.default.createElement(
	          'span',
	          { style: _extends({}, _constants.wrapperStyles, { maxHeight: maxHeight }) },
	          _react2.default.createElement(
	            'span',
	            { style: _constants.childrenStyles },
	            children,
	            overflow
	          ),
	          _react2.default.createElement(
	            'span',
	            { ref: function ref(node) {
	                _this4.spreader = node;
	              }, style: _constants.spreaderStyles, 'aria-hidden': 'true' },
	            this.state.allChildren
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: _constants.sizerWrapperStyles, 'aria-hidden': 'true' },
	            _react2.default.createElement(
	              'span',
	              { ref: function ref(node) {
	                  _this4.sizer = node;
	                }, style: _constants.block },
	              vertSpacers
	            ),
	            _react2.default.createElement(
	              'span',
	              { ref: function ref(node) {
	                  _this4.testChildren = node;
	                }, style: _constants.block },
	              testChildren,
	              overflow
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Shiitake;
	}(_react2.default.Component);
	
	Shiitake.propTypes = {
	  lines: _propTypes2.default.number.isRequired,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.string.isRequired,
	  renderFullOnServer: _propTypes2.default.bool,
	  throttleRate: _propTypes2.default.number,
	  tagName: _propTypes2.default.string,
	  overflowNode: _propTypes2.default.node,
	  onTruncationChange: _propTypes2.default.func
	};
	Shiitake.defaultProps = {
	  className: '',
	  renderFullOnServer: false,
	  throttleRate: undefined,
	  tagName: undefined,
	  overflowNode: '\u2026',
	  // in case someone accidentally passes something undefined in as children
	  children: '',
	  onTruncationChange: undefined
	};
	exports.default = Shiitake;

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // LIBS
	
	
	// INTERFACE
	var EventCalendarForm = function (_React$Component) {
	  _inherits(EventCalendarForm, _React$Component);
	
	  function EventCalendarForm() {
	    _classCallCheck(this, EventCalendarForm);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  EventCalendarForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'col-md-8 col-md-offset-2 CourseCalendarCity' },
	      _react2.default.createElement(
	        'p',
	        { style: { textAlign: 'center' } },
	        'Want to hold your event at Code Fellows? ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://docs.google.com/forms/d/e/1FAIpQLSfooWndn_zDxUvtkpdt3B1fp32mbHPYsOWcALwKapsWbhbn2w/viewform', target: '_blank' },
	          'Get in touch \xBB'
	        )
	      )
	    );
	  };
	
	  return EventCalendarForm;
	}(_react2.default.Component);
	
	exports.default = EventCalendarForm;
	module.exports = exports['default'];

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(292);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // LIBS
	
	
	// COMPONENTS
	
	
	// INTERFACE
	var EventCalendarItems = function (_React$Component) {
	  _inherits(EventCalendarItems, _React$Component);
	
	  function EventCalendarItems() {
	    _classCallCheck(this, EventCalendarItems);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  EventCalendarItems.prototype.render = function render() {
	    var events = this.props.events;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'event-calendar-items' },
	      events.length ? events.map(function (e, i) {
	        return _react2.default.createElement(_index2.default, { key: i, event: e });
	      }) : _react2.default.createElement(
	        'h1',
	        null,
	        'No events found'
	      )
	    );
	  };
	
	  return EventCalendarItems;
	}(_react2.default.Component);
	
	exports.default = EventCalendarItems;
	module.exports = exports['default'];

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(12);
	
	var _shiitake = __webpack_require__(2069);
	
	var _shiitake2 = _interopRequireDefault(_shiitake);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // LIBS
	
	
	// HELPERS
	
	// required for the clipping of the description
	
	
	var defaultImage = 'https://images.ctfassets.net/k428n7s2pxlu/1o6PhW35WMKKO6eyy8Yma8/891420f8777d6d0bbbb1635a5615d732/clement-h-544786-unsplash-square.jpg';
	
	// INTERFACE
	
	var EventCalendarItem = function (_React$Component) {
	  _inherits(EventCalendarItem, _React$Component);
	
	  function EventCalendarItem(props) {
	    _classCallCheck(this, EventCalendarItem);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      smallScreen: false
	    };
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    return _this;
	  }
	
	  EventCalendarItem.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== 'undefined') {
	      window.addEventListener('resize', this.handleWindowResize);
	    }
	  };
	
	  EventCalendarItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (typeof window !== 'undefined') {
	      window.removeEventListener('resize', this.handleWindowResize);
	    }
	  };
	
	  EventCalendarItem.prototype.handleWindowResize = function handleWindowResize() {
	    this.setState({ smallScreen: window.innerWidth < 700 });
	  };
	
	  EventCalendarItem.prototype.render = function render() {
	    var _props$event = this.props.event,
	        eventImage = _props$event.eventImage,
	        title = _props$event.title,
	        location = _props$event.location,
	        signup_url = _props$event.signup_url,
	        formatted_date = _props$event.formatted_date,
	        start_time = _props$event.start_time,
	        end_time = _props$event.end_time,
	        description = _props$event.description;
	
	
	    var fullTimeString = start_time + ' ' + (end_time ? '\u2013 ' + end_time : '');
	
	    return _react2.default.createElement(
	      'article',
	      { itemScope: true, itemType: 'http://shchema.org/Event', className: 'calendar-event cf event-calendar-item' },
	      _react2.default.createElement(
	        'div',
	        { className: 'event-image-container' },
	        _react2.default.createElement('img', { className: 'event-image', src: eventImage || defaultImage })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'details' },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(
	            'h1',
	            { itemProp: 'name' },
	            title
	          ),
	          _react2.default.createElement(
	            'h2',
	            { itemProp: 'startDate' },
	            formatted_date
	          ),
	          _react2.default.createElement(
	            'h2',
	            { itemProp: 'doorTime', content: start_time },
	            fullTimeString,
	            ' '
	          ),
	          _react2.default.createElement(
	            'h2',
	            { itemProp: 'location' },
	            location
	          )
	        ),
	        (0, _util.renderIf)(this.state.smallScreen, _react2.default.createElement(
	          _shiitake2.default,
	          { lines: 4, tagName: 'p', itemProp: 'description' },
	          description
	        )),
	        (0, _util.renderIf)(!this.state.smallScreen, _react2.default.createElement(
	          _shiitake2.default,
	          { lines: 2, tagName: 'p', itemProp: 'description' },
	          description
	        )),
	        _react2.default.createElement(
	          'div',
	          { className: 'action-buttons' },
	          _react2.default.createElement(
	            'a',
	            { itemProp: 'url', href: signup_url, target: '_blank' },
	            'RSVP'
	          )
	        )
	      )
	    );
	  };
	
	  return EventCalendarItem;
	}(_react2.default.Component);
	
	exports.default = EventCalendarItem;
	module.exports = exports['default'];

/***/ }),

/***/ 1947:
/***/ (function(module, exports) {

	module.exports = {"events":[{"event":{"type":"Non-Course Event","code":"","image":"https://images.ctfassets.net/k428n7s2pxlu/50gV7CHMT9OAcJZXnxbPc1/ac386915fecd2e8e64a9c24db83631c9/General_Event.jpg","title":"Partner Power Hour - Citizen Developers: Embracing a New Era of Building","startDate":"Friday, Aug 18, 2023","endDate":"Friday, Aug 18, 2023","formattedEventDate":"Friday, August 18, 2023","startTime":"12:15 PM","endTime":"1:00 PM","description":"Delve into the world of Citizen Developers - individuals who bridge the gap between technology and innovation, with or without traditional coding backgrounds. Discover their role in shaping the future of organizations and how they bring unique value to the table. Learn from industry experts about the untapped potential of Citizen Developers and how their creativity and problem-solving skills are revolutionizing development processes. Learn how you can work as a Citizen Developer yourself, or how you can effectively manage these dynamic contributors and leverage their talents within your teams. Embrace this new era of collaboration and find out how Citizen Developers are driving digital transformation in today’s fast-paced world. Join us for an interactive and engaging event that will leave you inspired and equipped with the knowledge to make the most of this evolving landscape.","quarter":"3","cancelled":false,"family":"","price":0,"signupUrl":"https://www.eventbrite.com/e/partner-power-hour-citizen-developers-embracing-a-new-era-of-building-tickets-697120234387","eventId":"697120234387","sequence":"","sequenceAndFamily":"","publicationState":"Planned","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"","city":"","state":"","zipCode":""}}},{"event":{"type":"Course","code":"seattle-ops-cybersecurity-401d12","image":"https://images.ctfassets.net/k428n7s2pxlu/62xZGIW0beMzOaDwWdQhK1/b15d92d8e5c3f7c291cd3caabcc84ddf/Final_Presentations.jpg","title":"Cybersecurity 401 Virtual Final Presentations","startDate":"Friday, Jul 05, 2024","endDate":"Friday, Jul 05, 2024","formattedEventDate":"Friday, July 05, 2024","startTime":"3:30 PM","endTime":"5:00 PM","description":"Join our community in celebrating the accomplishments of our Cybersecurity 401 students while also getting an exclusive look at the projects that are created during a week-long development sprint. The group presentations will give you a great sense of the stories and backgrounds of the students coming out of Code Fellows, while also providing insights into the skill sets gained over the past weeks. In just 5 days, these students plan, build, and launch an MVP to demonstrate their development capabilities. There is no better way to be part of our community while also gaining early access to the talent from our program than joining this event!","quarter":"3","cancelled":false,"family":"cybersecurity-401","price":0,"signupUrl":"https://www.eventbrite.com/e/706124666887","eventId":"706124666887","sequence":"ops","sequenceAndFamily":"ops-cybersecurity-401","publicationState":"In Progress","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"1701 Broadway","city":"Seattle","state":"WA","zipCode":"98122"}}},{"event":{"type":"Non-Course Event","code":"","image":"https://images.ctfassets.net/k428n7s2pxlu/50gV7CHMT9OAcJZXnxbPc1/ac386915fecd2e8e64a9c24db83631c9/General_Event.jpg","title":"Self-Paced Virtual Presentations","startDate":"Friday, Oct 20, 2023","endDate":"Friday, Oct 20, 2023","formattedEventDate":"Friday, October 20, 2023","startTime":"1:30 PM","endTime":"3:00 PM","description":"Join our community in celebrating the accomplishments of our students while also getting an exclusive look at the projects that are created during a week-long development sprint. The group presentations will give you a great sense of the stories and backgrounds of the students coming out of Code Fellows, while also providing insights into the skill sets gained over the past weeks. In just a few days, these students plan, build, and launch an MVP to demonstrate their technical capabilities.There is no better way to be part of our community while also gaining early access to the talent from our program than by joining this event!","quarter":"4","cancelled":false,"family":"","price":0,"signupUrl":"https://www.eventbrite.com/e/self-paced-virtual-presentations-tickets-733559013757","eventId":"733559013757","sequence":"","sequenceAndFamily":"","publicationState":"Planned","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"","city":"","state":"","zipCode":""}}},{"event":{"type":"Non-Course Event","code":"","image":"https://images.ctfassets.net/k428n7s2pxlu/50gV7CHMT9OAcJZXnxbPc1/ac386915fecd2e8e64a9c24db83631c9/General_Event.jpg","title":"Self-Paced Virtual Presentations II","startDate":"Friday, Oct 27, 2023","endDate":"Friday, Oct 27, 2023","formattedEventDate":"Friday, October 27, 2023","startTime":"1:30 PM","endTime":"3:00 PM","description":"Join our community in celebrating the accomplishments of our students while also getting an exclusive look at the projects that are created during a week-long development sprint. The group presentations will give you a great sense of the stories and backgrounds of the students coming out of Code Fellows, while also providing insights into the skill sets gained over the past weeks. In just a few days, these students plan, build, and launch an MVP to demonstrate their technical capabilities.There is no better way to be part of our community while also gaining early access to the talent from our program than by joining this event!","quarter":"4","cancelled":false,"family":"","price":0,"signupUrl":"https://www.eventbrite.com/e/741130389947","eventId":"741130389947","sequence":"","sequenceAndFamily":"","publicationState":"Planned","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"","city":"","state":"","zipCode":""}}},{"event":{"type":"Course","code":"seattle-code-javascript-401d58","image":"https://images.ctfassets.net/k428n7s2pxlu/62xZGIW0beMzOaDwWdQhK1/b15d92d8e5c3f7c291cd3caabcc84ddf/Final_Presentations.jpg","title":"Javascript 401 Virtual Final Presentations","startDate":"Friday, Jul 05, 2024","endDate":"Friday, Jul 05, 2024","formattedEventDate":"Friday, July 05, 2024","startTime":"1:30 PM","endTime":"3:00 PM","description":"Join our community in celebrating the accomplishments of our Javascript 401 students while also getting an exclusive look at the projects that are created during a week-long development sprint. The group presentations will give you a great sense of the stories and backgrounds of the students coming out of Code Fellows, while also providing insights into the skill sets gained over the past weeks. In just 5 days, these students plan, build, and launch an MVP to demonstrate their development capabilities. There is no better way to be part of our community while also gaining early access to the talent from our program than joining this event!","quarter":"3","cancelled":false,"family":"javascript-401","price":0,"signupUrl":"https://www.eventbrite.com/e/759233667337","eventId":"759233667337","sequence":"code","sequenceAndFamily":"code-javascript-401","publicationState":"In Progress","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"1701 Broadway","city":"Seattle","state":"WA","zipCode":"98122"}}},{"event":{"type":"Non-Course Event","code":"","image":"https://images.ctfassets.net/k428n7s2pxlu/50gV7CHMT9OAcJZXnxbPc1/ac386915fecd2e8e64a9c24db83631c9/General_Event.jpg","title":"Self-Paced Virtual Presentations","startDate":"Friday, Dec 22, 2023","endDate":"Friday, Dec 22, 2023","formattedEventDate":"Friday, December 22, 2023","startTime":"10:00 AM","endTime":"11:30 AM","description":"Join our community in celebrating the accomplishments of our students while also getting an exclusive look at the projects that are created during a week-long development sprint. The group presentations will give you a great sense of the stories and backgrounds of the students coming out of Code Fellows, while also providing insights into the skill sets gained over the past weeks. In just a few days, these students plan, build, and launch an MVP to demonstrate their technical capabilities.There is no better way to be part of our community while also gaining early access to the talent from our program than by joining this event!","quarter":"4","cancelled":false,"family":"","price":0,"signupUrl":"https://www.eventbrite.com/e/self-paced-virtual-presentations-tickets-778447777257","eventId":"778447777257","sequence":"","sequenceAndFamily":"","publicationState":"Planned","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"","city":"","state":"","zipCode":""}}},{"event":{"type":"Non-Course Event","code":"","image":"https://images.ctfassets.net/k428n7s2pxlu/50gV7CHMT9OAcJZXnxbPc1/ac386915fecd2e8e64a9c24db83631c9/General_Event.jpg","title":"Self-Paced Virtual Presentations","startDate":"Friday, Jan 19, 2024","endDate":"Friday, Jan 19, 2024","formattedEventDate":"Friday, January 19, 2024","startTime":"1:30 PM","endTime":"3:00 PM","description":"Join our community in celebrating the accomplishments of our students while also getting an exclusive look at the projects that are created during a week-long development sprint. The group presentations will give you a great sense of the stories and backgrounds of the students coming out of Code Fellows, while also providing insights into the skill sets gained over the past weeks. In just a few days, these students plan, build, and launch an MVP to demonstrate their technical capabilities.There is no better way to be part of our community while also gaining early access to the talent from our program than by joining this event!","quarter":"1","cancelled":false,"family":"","price":0,"signupUrl":"https://www.eventbrite.com/e/self-paced-virtual-presentations-tickets-788735367717","eventId":"788735367717","sequence":"","sequenceAndFamily":"","publicationState":"Planned","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"","city":"","state":"","zipCode":""}}},{"event":{"type":"Non-Course Event","code":"","image":"https://images.ctfassets.net/k428n7s2pxlu/50gV7CHMT9OAcJZXnxbPc1/ac386915fecd2e8e64a9c24db83631c9/General_Event.jpg","title":"Self-Paced Virtual Presentations","startDate":"Friday, Jan 05, 2024","endDate":"Friday, Jan 05, 2024","formattedEventDate":"Friday, January 05, 2024","startTime":"1:30 PM","endTime":"3:00 PM","description":"Join our community in celebrating the accomplishments of our students while also getting an exclusive look at the projects that are created during a week-long development sprint. The group presentations will give you a great sense of the stories and backgrounds of the students coming out of Code Fellows, while also providing insights into the skill sets gained over the past weeks. In just a few days, these students plan, build, and launch an MVP to demonstrate their technical capabilities.There is no better way to be part of our community while also gaining early access to the talent from our program than by joining this event!","quarter":"1","cancelled":false,"family":"","price":0,"signupUrl":"https://www.eventbrite.com/e/self-paced-virtual-presentations-tickets-788733542257","eventId":"788733542257","sequence":"","sequenceAndFamily":"","publicationState":"Planned","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"","city":"","state":"","zipCode":""}}},{"event":{"type":"Non-Course Event","code":"","image":"https://images.ctfassets.net/k428n7s2pxlu/50gV7CHMT9OAcJZXnxbPc1/ac386915fecd2e8e64a9c24db83631c9/General_Event.jpg","title":"Self-Paced Virtual Presentations","startDate":"Friday, Feb 23, 2024","endDate":"Friday, Feb 23, 2024","formattedEventDate":"Friday, February 23, 2024","startTime":"1:30 PM","endTime":"3:00 PM","description":"Join our community in celebrating the accomplishments of our students while also getting an exclusive look at the projects that are created during a week-long development sprint. The group presentations will give you a great sense of the stories and backgrounds of the students coming out of Code Fellows, while also providing insights into the skill sets gained over the past weeks. In just a few days, these students plan, build, and launch an MVP to demonstrate their technical capabilities.There is no better way to be part of our community while also gaining early access to the talent from our program than by joining this event!","quarter":"1","cancelled":false,"family":"","price":0,"signupUrl":"https://www.eventbrite.com/e/self-paced-virtual-presentations-tickets-847661627747","eventId":"847661627747","sequence":"","sequenceAndFamily":"","publicationState":"Planned","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"","city":"","state":"","zipCode":""}}},{"event":{"type":"Non-Course Event","code":"","image":"https://images.ctfassets.net/k428n7s2pxlu/50gV7CHMT9OAcJZXnxbPc1/ac386915fecd2e8e64a9c24db83631c9/General_Event.jpg","title":"Self-Paced Virtual Presentations","startDate":"Friday, Mar 29, 2024","endDate":"Friday, Mar 29, 2024","formattedEventDate":"Friday, March 29, 2024","startTime":"1:30 PM","endTime":"3:00 PM","description":"Join our community in celebrating the accomplishments of our students while also getting an exclusive look at the projects that are created during a week-long development sprint. The group presentations will give you a great sense of the stories and backgrounds of the students coming out of Code Fellows, while also providing insights into the skill sets gained over the past weeks. In just a few days, these students plan, build, and launch an MVP to demonstrate their technical capabilities.There is no better way to be part of our community while also gaining early access to the talent from our program than by joining this event!","quarter":"1","cancelled":false,"family":"","price":0,"signupUrl":"https://www.eventbrite.com/e/self-paced-virtual-presentations-tickets-872649166147","eventId":"872649166147","sequence":"","sequenceAndFamily":"","publicationState":"Planned","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"","city":"","state":"","zipCode":""}}},{"event":{"type":"Non-Course Event","code":"","image":"https://images.ctfassets.net/k428n7s2pxlu/50gV7CHMT9OAcJZXnxbPc1/ac386915fecd2e8e64a9c24db83631c9/General_Event.jpg","title":"Self-Paced Virtual Presentations","startDate":"Friday, Apr 26, 2024","endDate":"Friday, Apr 26, 2024","formattedEventDate":"Friday, April 26, 2024","startTime":"1:30 PM","endTime":"3:00 PM","description":"Join our community in celebrating the accomplishments of our students while also getting an exclusive look at the projects that are created during a week-long development sprint. The group presentations will give you a great sense of the stories and backgrounds of the students coming out of Code Fellows, while also providing insights into the skill sets gained over the past weeks. In just a few days, these students plan, build, and launch an MVP to demonstrate their technical capabilities.There is no better way to be part of our community while also gaining early access to the talent from our program than by joining this event!","quarter":"2","cancelled":false,"family":"","price":0,"signupUrl":"https://www.eventbrite.com/e/self-paced-virtual-presentations-tickets-891135729957","eventId":"891135729957","sequence":"","sequenceAndFamily":"","publicationState":"Planned","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"","city":"","state":"","zipCode":""}}},{"event":{"type":"Non-Course Event","code":"","image":"https://images.ctfassets.net/k428n7s2pxlu/50gV7CHMT9OAcJZXnxbPc1/ac386915fecd2e8e64a9c24db83631c9/General_Event.jpg","title":"Self-Paced Virtual Presentations","startDate":"Friday, Jun 14, 2024","endDate":"Friday, Jun 14, 2024","formattedEventDate":"Friday, June 14, 2024","startTime":"1:30 PM","endTime":"3:00 PM","description":"Join our community in celebrating the accomplishments of our students while also getting an exclusive look at the projects that are created during a week-long development sprint. The group presentations will give you a great sense of the stories and backgrounds of the students coming out of Code Fellows, while also providing insights into the skill sets gained over the past weeks. In just a few days, these students plan, build, and launch an MVP to demonstrate their technical capabilities.There is no better way to be part of our community while also gaining early access to the talent from our program than by joining this event!","quarter":"2","cancelled":false,"family":"","price":0,"signupUrl":"https://www.eventbrite.com/e/self-paced-virtual-presentations-tickets-923116555467","eventId":"923116555467","sequence":"","sequenceAndFamily":"","publicationState":"Planned","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"","city":"","state":"","zipCode":""}}},{"event":{"type":"Non-Course Event","code":"","image":"https://images.ctfassets.net/k428n7s2pxlu/50gV7CHMT9OAcJZXnxbPc1/ac386915fecd2e8e64a9c24db83631c9/General_Event.jpg","title":"Self-Paced Virtual Presentations","startDate":"Friday, Jun 28, 2024","endDate":"Friday, Jun 28, 2024","formattedEventDate":"Friday, June 28, 2024","startTime":"1:00 PM","endTime":"1:30 PM","description":"Join our community in celebrating the accomplishments of our students while also getting an exclusive look at the projects that are created during a week-long development sprint. The group presentations will give you a great sense of the stories and backgrounds of the students coming out of Code Fellows, while also providing insights into the skill sets gained over the past weeks. In just a few days, these students plan, build, and launch an MVP to demonstrate their technical capabilities.There is no better way to be part of our community while also gaining early access to the talent from our program than by joining this event!","quarter":"2","cancelled":false,"family":"","price":0,"signupUrl":"https://www.eventbrite.com/e/self-paced-virtual-presentations-tickets-933984561967","eventId":"933984561967","sequence":"","sequenceAndFamily":"","publicationState":"Planned","onlineVsInPerson":"Online","location":{"name":"Zoom Call - RSVP for the latest updates.","streetAddress":"","city":"","state":"","zipCode":""}}}],"designateLocation":false,"updated":"2024-06-25 16:26:54 -0700"}

/***/ }),

/***/ 1959:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__(1959);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(96);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _eventSchedule = __webpack_require__(1947);
	
	var _eventSchedule2 = _interopRequireDefault(_eventSchedule);
	
	var _util = __webpack_require__(12);
	
	var _metaData = __webpack_require__(14);
	
	var _metaData2 = _interopRequireDefault(_metaData);
	
	var _index = __webpack_require__(290);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(291);
	
	var _index4 = _interopRequireDefault(_index3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // STYLE
	
	
	// LIBS
	
	
	// HELPERS
	
	
	// COMPONENTS
	
	
	var headerStyle = {
	  background: 'url("https://images.ctfassets.net/k428n7s2pxlu/1lzictumvmwoMg82Oy2M4i/db5549017347046280ba58c94d38b415/calendar-header.jpg") center center no-repeat',
	  backgroundSize: 'cover'
	
	  // INTERFACE
	};
	var EventCalendar = function (_React$Component) {
	  _inherits(EventCalendar, _React$Component);
	
	  function EventCalendar(props) {
	    _classCallCheck(this, EventCalendar);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      schedule: (0, _util.prepareRaw)(_eventSchedule2.default, 'event'),
	      designateLocationState: null
	    };
	    return _this;
	  }
	
	  EventCalendar.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _axios2.default.get('https://s3.us-west-2.amazonaws.com/static.codefellows.org/events/event_schedule.json?ts=' + Date.now()).then(function (result) {
	      if (result.data && result.data.events && result.data.events.length) {
	        _this2.setState({
	          schedule: (0, _util.prepareRaw)(result.data, 'event'),
	          designateLocationState: result.data.designateLocation
	        });
	      }
	    }).catch(function (err) {
	      return console.error('errrrr', err);
	    });
	  };
	
	  EventCalendar.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'custom_pages events-calendar' },
	      _react2.default.createElement(_metaData2.default, { data: {
	          slug: 'events-calendar',
	          title: 'Demo Days & Info Sessions | Code Fellows',
	          description: 'Code Fellows event calendar'
	        } }),
	      _react2.default.createElement(
	        'header',
	        { className: 'custom-page-header', style: headerStyle },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Events'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { paddingTop: '1.5em' }, className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar' },
	          _react2.default.createElement(_index4.default, { events: this.state.schedule })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'calendar' },
	          _react2.default.createElement(_index2.default, null)
	        )
	      )
	    );
	  };
	
	  return EventCalendar;
	}(_react2.default.Component);
	
	exports.default = EventCalendar;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-events-calendar-index-js-cacd2bb6e7b475b7166e.js